@if (session) {
  <div
    class="remote-app-hover flex-row align-start-center"
    [class.remote-app-active]="isSessionActive()"
    (click)="onSessionClick(session)">
    <div [matTooltip]="session.getLabel()"
      [matTooltipDisabled]="!session.getLabel() || grouped"
      [class.grouped]="grouped"
      class="remote-app-icon-bg flex-col align-center-center"
      matTooltipPosition="right">
      <div class="remote-app flex-col align-center-center">
        @if (session.getThumbnail()) {
          <img [src]="session.getThumbnail()"
            width="32"
            height="32" class="remote-app-img" loading="lazy"/>
        } @else {
          <img src="assets/icons/hourglass.png" width="32" height="32" class="remote-app-img" />
        }
      </div>
      @if (!grouped) {
        <div class="remote-app-open-indicator-space"
          [class.remote-app-open-indicator]="true"
          [class.remote-app-open-indicator-active]="isSessionActive()">
        </div>
      }
    </div>
    @if (grouped) {
      <div class="session-label flex-1">
        {{session.getLabel()}}
      </div>
    }
  </div>
}
